import DatetimeField from './datetime-field'
import InputBoxField from './input-box-field'
import RadioSelectField from './radio-select-field'
import SelectField from './select-field'
import TagBoxField from './tag-box-field'
import TextareaField from './textarea-field'

export default {
    DatetimeField,
    InputBoxField,
    RadioSelectField,
    SelectField,
    TagBoxField,
    TextareaField,
}
